module.exports = __webpack_public_path__ + "img/kel-unid-sao-leopoldo.3ca6b822.jpg";